import CreateEditOperators from "../../Components/OperatorManagement/CreateEditOperator";

export default function CreateEditOperator(){
    return(
        <CreateEditOperators/>
    )
}